import Detail from "./Detail";
import Events from "./Events";
import Hero from "./Hero";
import Follow from "./Follow";
import Resources from "./Resources";

export default {
  Detail,
  Events,
  Hero,
  Follow,
  Resources
};
